export const ANIMALS = [
    ["cat", "🐱", "Кошка"], ["dog", "🐶", "Собака"], ["fox", "🦊", "Лиса"], ["panda", "🐼", "Панда"],
    ["koala", "🐨", "Коала"], ["rabbit", "🐰", "Кролик"], ["tiger", "🐯", "Тигр"], ["lion", "🦁", "Лев"],
    ["bear", "🐻", "Медведь"], ["owl", "🦉", "Сова"], ["penguin", "🐧", "Пингвин"], ["frog", "🐸", "Лягушка"]
];
export const animalFor = (avatar, id) => ANIMALS.find(item => item[0] === avatar) || ANIMALS[Math.abs(Number(id) || 0) % ANIMALS.length];
